import React from 'react';

const activities = () => {
  return (
    <div>
      activities
    </div>
  );
}

export default activities;
